<template>
  <div>
    <span v-html="activityMessage"></span>
  </div>
</template>

<script>
export default {
  name: 'ContactModuleRulesDisabled',
  props: {
    activity: {
      type: Object,
      required: true
    }
  },
  computed: {
    activityMessage() {
      const actor = this.activity?.actorUser?.name || 'Bilinmeyen Kullanıcı';
      
      return this.$t('notification.contactModuleRulesDisabled', {
        actor: `<strong>${actor}</strong>`
      });
    }
  }
};
</script>

<style scoped>
</style>

